import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Badge } from '@/components/ui/badge';
import {
  Shield,
  Search,
  Download,
  RefreshCw,
  Eye,
  AlertTriangle,
  CheckCircle2,
  LogIn,
  LogOut,
  Plus,
  Pencil,
  Trash2,
  UserCheck,
  ChevronLeft,
  ChevronRight,
  Filter,
  Clock,
  Activity,
  Users,
  Globe
} from 'lucide-react';

const mockAuditLogs = [
  { id: 'al_001', actor_name: 'Ahmet Yılmaz', actor_id: 'usr_011', action: 'LOGIN', entity: 'auth', entity_id: null, org_name: 'Istanbul Fair Solutions', ip: '89.244.123.45', timestamp: '2025-01-10T10:30:00Z', risk: 'low' },
  { id: 'al_002', actor_name: 'Admin User', actor_id: 'usr_admin', action: 'IMPERSONATE_START', entity: 'user', entity_id: 'usr_033', org_name: 'System', ip: '192.168.1.100', timestamp: '2025-01-10T10:28:00Z', risk: 'high' },
  { id: 'al_003', actor_name: 'Sarah Johnson', actor_id: 'usr_022', action: 'UPDATE', entity: 'brief', entity_id: 'brief_456', org_name: 'Global Exhibitions Inc.', ip: '185.94.56.12', timestamp: '2025-01-10T10:15:00Z', risk: 'low' },
  { id: 'al_004', actor_name: 'Mehmet Kaya', actor_id: 'usr_033', action: 'CREATE', entity: 'proposal', entity_id: 'prop_789', org_name: 'Ankara Stand Supplies', ip: '78.189.22.11', timestamp: '2025-01-10T09:55:00Z', risk: 'low' },
  { id: 'al_005', actor_name: 'Hans Müller', actor_id: 'usr_044', action: 'DELETE', entity: 'file', entity_id: 'file_123', org_name: 'Berlin Trade Shows', ip: '80.187.5.90', timestamp: '2025-01-10T09:40:00Z', risk: 'medium' },
  { id: 'al_006', actor_name: 'Emma Wilson', actor_id: 'usr_055', action: 'LOGIN', entity: 'auth', entity_id: null, org_name: 'London Expo Hub', ip: '82.112.44.7', timestamp: '2025-01-10T09:30:00Z', risk: 'low' },
  { id: 'al_007', actor_name: 'Admin User', actor_id: 'usr_admin', action: 'PLAN_CHANGE', entity: 'subscription', entity_id: 'sub_002', org_name: 'System', ip: '192.168.1.100', timestamp: '2025-01-10T09:20:00Z', risk: 'medium' },
  { id: 'al_008', actor_name: 'Ayşe Demir', actor_id: 'usr_066', action: 'LOGOUT', entity: 'auth', entity_id: null, org_name: 'Izmir Fair Co.', ip: '94.55.12.88', timestamp: '2025-01-10T09:10:00Z', risk: 'low' },
  { id: 'al_009', actor_name: 'Carlos Garcia', actor_id: 'usr_077', action: 'FAILED_LOGIN', entity: 'auth', entity_id: null, org_name: 'Madrid Events', ip: '212.33.8.55', timestamp: '2025-01-10T08:58:00Z', risk: 'high' },
  { id: 'al_010', actor_name: 'Admin User', actor_id: 'usr_admin', action: 'DELETE', entity: 'organization', entity_id: 'org_009', org_name: 'System', ip: '192.168.1.100', timestamp: '2025-01-10T08:40:00Z', risk: 'high' },
  { id: 'al_011', actor_name: 'Fatma Şahin', actor_id: 'usr_088', action: 'CREATE', entity: 'brief', entity_id: 'brief_500', org_name: 'Bursa Expo Design', ip: '78.174.9.22', timestamp: '2025-01-10T08:30:00Z', risk: 'low' },
  { id: 'al_012', actor_name: 'Pierre Dupont', actor_id: 'usr_099', action: 'UPDATE', entity: 'subscription', entity_id: 'sub_007', org_name: 'Paris Trade Fair', ip: '195.24.30.1', timestamp: '2025-01-10T08:15:00Z', risk: 'low' },
  { id: 'al_013', actor_name: 'Admin User', actor_id: 'usr_admin', action: 'IMPERSONATE_END', entity: 'user', entity_id: 'usr_033', org_name: 'System', ip: '192.168.1.100', timestamp: '2025-01-10T08:00:00Z', risk: 'medium' },
  { id: 'al_014', actor_name: 'John Smith', actor_id: 'usr_101', action: 'CREATE', entity: 'proposal', entity_id: 'prop_800', org_name: 'New York Trade Inc.', ip: '104.21.66.3', timestamp: '2025-01-10T07:45:00Z', risk: 'low' },
  { id: 'al_015', actor_name: 'Kemal Yıldız', actor_id: 'usr_112', action: 'FAILED_LOGIN', entity: 'auth', entity_id: null, org_name: 'Ankara Stand Supplies', ip: '78.189.77.55', timestamp: '2025-01-10T07:30:00Z', risk: 'high' },
  { id: 'al_016', actor_name: 'Maria Rossi', actor_id: 'usr_123', action: 'UPDATE', entity: 'profile', entity_id: 'usr_123', org_name: 'Rome Expo Agency', ip: '151.38.44.22', timestamp: '2025-01-10T07:20:00Z', risk: 'low' },
  { id: 'al_017', actor_name: 'Admin User', actor_id: 'usr_admin', action: 'PLAN_CHANGE', entity: 'organization', entity_id: 'org_005', org_name: 'System', ip: '192.168.1.100', timestamp: '2025-01-10T07:05:00Z', risk: 'medium' },
  { id: 'al_018', actor_name: 'Zeynep Arslan', actor_id: 'usr_134', action: 'LOGIN', entity: 'auth', entity_id: null, org_name: 'Konya Fair Solutions', ip: '78.162.55.9', timestamp: '2025-01-10T06:50:00Z', risk: 'low' },
  { id: 'al_019', actor_name: 'Thomas Fischer', actor_id: 'usr_145', action: 'CREATE', entity: 'brief', entity_id: 'brief_501', org_name: 'Frankfurt Trade GmbH', ip: '195.56.88.100', timestamp: '2025-01-10T06:40:00Z', risk: 'low' },
  { id: 'al_020', actor_name: 'Admin User', actor_id: 'usr_admin', action: 'DELETE', entity: 'user', entity_id: 'usr_zombie', org_name: 'System', ip: '192.168.1.100', timestamp: '2025-01-10T06:30:00Z', risk: 'high' },
];

const ACTION_CONFIG = {
  LOGIN:            { color: 'bg-emerald-100 text-emerald-800', icon: LogIn },
  LOGOUT:           { color: 'bg-gray-100 text-gray-700',       icon: LogOut },
  CREATE:           { color: 'bg-blue-100 text-blue-800',       icon: Plus },
  UPDATE:           { color: 'bg-yellow-100 text-yellow-800',   icon: Pencil },
  DELETE:           { color: 'bg-red-100 text-red-800',         icon: Trash2 },
  FAILED_LOGIN:     { color: 'bg-red-100 text-red-800',         icon: AlertTriangle },
  IMPERSONATE_START:{ color: 'bg-purple-100 text-purple-800',   icon: UserCheck },
  IMPERSONATE_END:  { color: 'bg-purple-100 text-purple-800',   icon: UserCheck },
  PLAN_CHANGE:      { color: 'bg-orange-100 text-orange-800',   icon: Activity },
};

const RISK_CONFIG = {
  low:    { color: 'bg-emerald-100 text-emerald-700', label: 'Düşük' },
  medium: { color: 'bg-yellow-100 text-yellow-700',  label: 'Orta' },
  high:   { color: 'bg-red-100 text-red-700',        label: 'Yüksek' },
};

const PAGE_SIZE = 8;

const UltraAudit = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [actionFilter, setActionFilter] = useState('all');
  const [riskFilter, setRiskFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [selectedLog, setSelectedLog] = useState(null);
  const [total, setTotal] = useState(0);

  const API = process.env.REACT_APP_BACKEND_URL;
  const getToken = () => localStorage.getItem('access_token') || sessionStorage.getItem('access_token');

  useEffect(() => { fetchLogs(); }, [search, actionFilter, page]);

  const fetchLogs = async () => {
    setLoading(true);
    try {
      const token = getToken();
      const params = new URLSearchParams({ page, limit: PAGE_SIZE });
      if (search) params.set('search', search);
      if (actionFilter !== 'all') params.set('action', actionFilter);
      const res = await axios.get(`${API}/api/ultra/audit?${params}`, { headers: { Authorization: `Bearer ${token}` } });
      const items = (res.data.items || []).map(l => ({
        id: l.id,
        actor_name: l.actor || l.actor_name || 'System',
        actor_id: l.actor_id,
        action: l.action,
        entity: l.entity,
        entity_id: l.entity_id,
        org_name: l.org_id || '',
        ip: l.ip || '—',
        timestamp: l.ts || l.created_at,
        risk: l.risk || (l.action === 'FAILED_LOGIN' || l.action === 'DELETE' ? 'high' : l.action === 'UPDATE' ? 'medium' : 'low'),
      }));
      setLogs(items);
      setTotal(res.data.total || items.length);
    } catch (err) {
      console.error('Audit fetch error:', err);
      setLogs(mockAuditLogs); // fallback to mock on error
    } finally {
      setLoading(false);
    }
  };

  const filtered = logs.filter(l => {
    const q = search.toLowerCase();
    const matchSearch = !q || (l.actor_name||'').toLowerCase().includes(q) || (l.org_name||'').toLowerCase().includes(q) || (l.ip||'').includes(q) || l.action.toLowerCase().includes(q);
    const matchAction = actionFilter === 'all' || l.action === actionFilter;
    const matchRisk = riskFilter === 'all' || l.risk === riskFilter;
    return matchSearch && matchAction && matchRisk;
  });

  const totalPages = Math.ceil((total || filtered.length) / PAGE_SIZE);
  const paged = filtered;

  const kpis = [
    { label: 'Toplam Kayıt', value: total || logs.length, icon: Shield, color: 'bg-blue-50 text-blue-600', change: `${logs.length} yüklendi` },
    { label: 'Yüksek Risk', value: logs.filter(l => l.risk === 'high').length, icon: AlertTriangle, color: 'bg-red-50 text-red-600', change: 'Dikkat gerektiriyor' },
    { label: 'Login Olayları', value: logs.filter(l => l.action === 'LOGIN').length, icon: Users, color: 'bg-emerald-50 text-emerald-600', change: 'Sayfa içinde' },
    { label: 'Benzersiz IP', value: new Set(logs.map(l => l.ip)).size, icon: Globe, color: 'bg-purple-50 text-purple-600', change: 'Benzersiz' },
  ];

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Denetim Logları</h1>
          <p className="text-sm text-gray-500 mt-0.5">Sistem genelindeki tüm aktivite ve güvenlik kayıtları</p>
        </div>
        <div className="flex gap-2">
          <Button variant="outline" size="sm" onClick={fetchLogs}>
            <RefreshCw className="h-4 w-4 mr-1.5" />Yenile
          </Button>
          <Button variant="outline" size="sm">
            <Download className="h-4 w-4 mr-1.5" />CSV İndir
          </Button>
        </div>
      </div>

      {/* KPI Cards */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {kpis.map((k, i) => {
          const Icon = k.icon;
          return (
            <Card key={i} className="border-0 shadow-sm">
              <CardContent className="p-5">
                <div className="flex items-start justify-between">
                  <div>
                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide">{k.label}</p>
                    <p className="text-3xl font-bold text-gray-900 mt-1">{k.value}</p>
                    <p className="text-xs text-gray-400 mt-1">{k.change}</p>
                  </div>
                  <div className={`p-2.5 rounded-xl ${k.color}`}>
                    <Icon className="h-5 w-5" />
                  </div>
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Filters */}
      <Card className="border-0 shadow-sm">
        <CardContent className="p-4">
          <div className="flex flex-wrap items-center gap-3">
            <div className="relative flex-1 min-w-[200px]">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 h-4 w-4" />
              <Input
                placeholder="Kullanıcı, org, IP, aksiyon ara..."
                value={search}
                onChange={e => { setSearch(e.target.value); setPage(1); }}
                className="pl-9 bg-gray-50 border-gray-200"
              />
            </div>
            <select
              value={actionFilter}
              onChange={e => { setActionFilter(e.target.value); setPage(1); }}
              className="px-3 py-2 border border-gray-200 rounded-md text-sm bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="all">Tüm Aksiyonlar</option>
              <option value="LOGIN">Giriş</option>
              <option value="LOGOUT">Çıkış</option>
              <option value="FAILED_LOGIN">Başarısız Giriş</option>
              <option value="CREATE">Oluşturma</option>
              <option value="UPDATE">Güncelleme</option>
              <option value="DELETE">Silme</option>
              <option value="IMPERSONATE_START">Taklit Başlat</option>
              <option value="PLAN_CHANGE">Plan Değişikliği</option>
            </select>
            <select
              value={riskFilter}
              onChange={e => { setRiskFilter(e.target.value); setPage(1); }}
              className="px-3 py-2 border border-gray-200 rounded-md text-sm bg-gray-50 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="all">Tüm Riskler</option>
              <option value="low">Düşük Risk</option>
              <option value="medium">Orta Risk</option>
              <option value="high">Yüksek Risk</option>
            </select>
            <span className="text-sm text-gray-400 ml-auto">{filtered.length} kayıt</span>
          </div>
        </CardContent>
      </Card>

      {/* Table */}
      <Card className="border-0 shadow-sm">
        <CardHeader className="pb-3 border-b border-gray-100">
          <CardTitle className="text-base flex items-center gap-2">
            <Shield className="h-5 w-5 text-blue-600" />
            Aktivite Akışı
          </CardTitle>
        </CardHeader>
        <CardContent className="p-0">
          {loading ? (
            <div className="p-6 space-y-3">
              {[...Array(6)].map((_, i) => (
                <div key={i} className="animate-pulse flex gap-4">
                  <div className="h-4 bg-gray-100 rounded w-32" />
                  <div className="h-4 bg-gray-100 rounded w-24" />
                  <div className="h-4 bg-gray-100 rounded w-20" />
                  <div className="h-4 bg-gray-100 rounded flex-1" />
                </div>
              ))}
            </div>
          ) : (
            <>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="bg-gray-50 border-b border-gray-100">
                      <th className="text-left py-3 px-4 font-semibold text-gray-600 text-xs uppercase tracking-wide">Zaman</th>
                      <th className="text-left py-3 px-4 font-semibold text-gray-600 text-xs uppercase tracking-wide">Kullanıcı</th>
                      <th className="text-left py-3 px-4 font-semibold text-gray-600 text-xs uppercase tracking-wide">Aksiyon</th>
                      <th className="text-left py-3 px-4 font-semibold text-gray-600 text-xs uppercase tracking-wide">Kaynak</th>
                      <th className="text-left py-3 px-4 font-semibold text-gray-600 text-xs uppercase tracking-wide">Organizasyon</th>
                      <th className="text-left py-3 px-4 font-semibold text-gray-600 text-xs uppercase tracking-wide">IP Adresi</th>
                      <th className="text-left py-3 px-4 font-semibold text-gray-600 text-xs uppercase tracking-wide">Risk</th>
                      <th className="text-left py-3 px-4 font-semibold text-gray-600 text-xs uppercase tracking-wide"></th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50">
                    {paged.map(log => {
                      const ac = ACTION_CONFIG[log.action] || ACTION_CONFIG['UPDATE'];
                      const rc = RISK_CONFIG[log.risk];
                      const ActionIcon = ac.icon;
                      return (
                        <tr key={log.id} className="hover:bg-gray-50 transition-colors">
                          <td className="py-3 px-4 text-gray-500 whitespace-nowrap">
                            <div className="flex items-center gap-1.5">
                              <Clock className="h-3.5 w-3.5 text-gray-400" />
                              {new Date(log.timestamp).toLocaleString('tr-TR', { day:'2-digit', month:'2-digit', hour:'2-digit', minute:'2-digit' })}
                            </div>
                          </td>
                          <td className="py-3 px-4">
                            <div className="font-medium text-gray-900">{log.actor_name}</div>
                            <div className="text-xs text-gray-400 font-mono">{log.actor_id}</div>
                          </td>
                          <td className="py-3 px-4">
                            <span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${ac.color}`}>
                              <ActionIcon className="h-3 w-3" />
                              {log.action.replace('_', ' ')}
                            </span>
                          </td>
                          <td className="py-3 px-4">
                            <div className="text-gray-800 capitalize">{log.entity}</div>
                            {log.entity_id && <div className="text-xs text-gray-400 font-mono">{log.entity_id}</div>}
                          </td>
                          <td className="py-3 px-4 text-gray-600">{log.org_name}</td>
                          <td className="py-3 px-4 font-mono text-xs text-gray-500">{log.ip}</td>
                          <td className="py-3 px-4">
                            <span className={`px-2 py-0.5 rounded text-xs font-medium ${rc.color}`}>{rc.label}</span>
                          </td>
                          <td className="py-3 px-4">
                            <Button size="sm" variant="ghost" className="h-7 px-2 text-gray-500 hover:text-gray-900" onClick={() => setSelectedLog(log)}>
                              <Eye className="h-3.5 w-3.5" />
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="flex items-center justify-between px-4 py-3 border-t border-gray-100">
                <span className="text-xs text-gray-500">
                  {(page - 1) * PAGE_SIZE + 1}–{Math.min(page * PAGE_SIZE, filtered.length)} / {filtered.length} kayıt
                </span>
                <div className="flex gap-1">
                  <Button variant="outline" size="sm" className="h-7 px-2" disabled={page === 1} onClick={() => setPage(p => p - 1)}>
                    <ChevronLeft className="h-4 w-4" />
                  </Button>
                  {[...Array(totalPages)].map((_, i) => (
                    <Button
                      key={i}
                      variant={page === i + 1 ? 'default' : 'outline'}
                      size="sm"
                      className="h-7 w-7 p-0 text-xs"
                      onClick={() => setPage(i + 1)}
                    >
                      {i + 1}
                    </Button>
                  ))}
                  <Button variant="outline" size="sm" className="h-7 px-2" disabled={page === totalPages} onClick={() => setPage(p => p + 1)}>
                    <ChevronRight className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            </>
          )}
        </CardContent>
      </Card>

      {/* Detail Modal */}
      {selectedLog && (
        <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center p-4" onClick={() => setSelectedLog(null)}>
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md p-6" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold text-gray-900">Log Detayı</h3>
              <Button variant="ghost" size="sm" onClick={() => setSelectedLog(null)}>✕</Button>
            </div>
            <div className="space-y-3 text-sm">
              {[
                ['Log ID', selectedLog.id],
                ['Kullanıcı', selectedLog.actor_name],
                ['Kullanıcı ID', selectedLog.actor_id],
                ['Aksiyon', selectedLog.action],
                ['Kaynak Tipi', selectedLog.entity],
                ['Kaynak ID', selectedLog.entity_id || '—'],
                ['Organizasyon', selectedLog.org_name],
                ['IP Adresi', selectedLog.ip],
                ['Risk Seviyesi', RISK_CONFIG[selectedLog.risk].label],
                ['Zaman', new Date(selectedLog.timestamp).toLocaleString('tr-TR')],
              ].map(([label, value]) => (
                <div key={label} className="flex justify-between py-2 border-b border-gray-50">
                  <span className="text-gray-500 font-medium">{label}</span>
                  <span className="text-gray-900 font-mono text-xs">{value}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default UltraAudit;
